import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiCalendar, FiTarget } = FiIcons;

const Experience = ({ data, language, detailed = false }) => {
  const experiences = detailed ? data : data.slice(0, 2);

  return (
    <section className={`${detailed ? 'py-12' : 'py-20'} px-6`}>
      <div className="container mx-auto max-w-6xl">
        {!detailed && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-stone-800 mb-6">
              Professional Experience
            </h2>
          </motion.div>
        )}

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-amber-600 to-stone-400"></div>

          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="relative ml-16"
              >
                <div className="absolute -left-20 top-6 w-4 h-4 bg-gradient-to-br from-amber-600 to-amber-700 rounded-full border-4 border-stone-100"></div>

                <div className="bg-white rounded-2xl p-8 border border-stone-200 shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="flex flex-wrap items-start justify-between mb-4">
                    <div>
                      <h3 className="text-2xl font-bold text-stone-800 mb-2">{exp.title}</h3>
                      <h4 className="text-xl text-amber-700 font-semibold mb-2">{exp.company}</h4>
                    </div>
                    <div className="flex flex-col items-end space-y-2">
                      <div className="flex items-center space-x-2 text-stone-500">
                        <SafeIcon icon={FiCalendar} className="text-sm" />
                        <span className="text-sm">{exp.period}</span>
                      </div>
                      <div className="flex items-center space-x-2 text-stone-500">
                        <SafeIcon icon={FiMapPin} className="text-sm" />
                        <span className="text-sm">{exp.location}</span>
                      </div>
                    </div>
                  </div>

                  <p className="text-stone-600 mb-6 leading-relaxed">{exp.description}</p>

                  {exp.achievements.length > 0 && (
                    <div className="mb-6">
                      <h5 className="text-lg font-semibold text-stone-800 mb-4 flex items-center">
                        <SafeIcon icon={FiTarget} className="mr-2 text-amber-600" />
                        {language === 'en' ? 'Key Responsibilities' : 'ความรับผิดชอบหลัก'}
                      </h5>
                      <ul className="space-y-2">
                        {exp.achievements.map((achievement, i) => (
                          <li key={i} className="text-stone-600 flex items-start">
                            <span className="text-amber-600 mr-2">•</span>
                            <span>{achievement}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;